"use strict";
/** @module BryxApi.ManagementApi */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ts_mixer_1 = require("ts-mixer");
var BryxApi_1 = require("../BryxApi");
var JobMixin_1 = require("./JobMixin");
var AgencyMixin_1 = require("./AgencyMixin");
var ApparatusMixin_1 = require("./ApparatusMixin");
var GroupMixin_1 = require("./GroupMixin");
var JoinRequestMixin_1 = require("./JoinRequestMixin");
var LocationServicesMixin_1 = require("./LocationServicesMixin");
var ResponseOptionsMixin_1 = require("./ResponseOptionsMixin");
var ScuAlertsMixin_1 = require("./ScuAlertsMixin");
var StationBoardMixin_1 = require("./StationBoardMixin");
var UserMixin_1 = require("./UserMixin");
var SCUMixin_1 = require("./SCUMixin");
var SiteSurveyMixin_1 = require("./SiteSurveyMixin");
var ReportMixin_1 = require("./ReportMixin");
var ManagementMixinA = /** @class */ (function (_super) {
    __extends(ManagementMixinA, _super);
    function ManagementMixinA() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ManagementMixinA;
}((0, ts_mixer_1.Mixin)(AgencyMixin_1.default, ApparatusMixin_1.default, GroupMixin_1.default, JobMixin_1.default, JoinRequestMixin_1.default, LocationServicesMixin_1.default, ResponseOptionsMixin_1.default, ReportMixin_1.default)));
var ManagementMixinB = /** @class */ (function (_super) {
    __extends(ManagementMixinB, _super);
    function ManagementMixinB() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ManagementMixinB;
}((0, ts_mixer_1.Mixin)(ScuAlertsMixin_1.default, SCUMixin_1.default, StationBoardMixin_1.default, UserMixin_1.default, SiteSurveyMixin_1.default)));
/**
 * Mixin class for management API calls.
 */
var ManagementMixin = /** @class */ (function (_super) {
    __extends(ManagementMixin, _super);
    function ManagementMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ManagementMixin;
}((0, ts_mixer_1.Mixin)(ManagementMixinA, ManagementMixinB)));
/**
 * Class for management API calls.
 */
var ManagementApi = /** @class */ (function (_super) {
    __extends(ManagementApi, _super);
    function ManagementApi(config, local, testResponses) {
        if (config === void 0) { config = { serverType: 'dev', site: 'test', version: '0', serverLocale: 'us' }; }
        var _this = _super.call(this, config, local, testResponses) || this;
        _this.dispatchUrl = "https://".concat(_this.urlPrefix, "dispatch.").concat(_this.baseHost);
        _this.stationBoardUrl = "https://".concat(_this.urlPrefix, "board.").concat(_this.baseHost);
        _this.toolsBaseUrl = "https://".concat(_this.urlPrefix, "tools.").concat(_this.baseHost);
        return _this;
    }
    return ManagementApi;
}((0, ts_mixer_1.Mixin)(BryxApi_1.default, ManagementMixin)));
exports.default = ManagementApi;
//# sourceMappingURL=index.js.map